import { ChangeDetectionStrategy, Component, effect, input, signal } from '@angular/core';
import { ContentType } from 'angular-to-phaser';
import { Subscription } from 'rxjs';
import { StaticContent } from 'src/app/dto';
import { ApplicationService } from 'src/app/services/application.service';
import { StaticContentService } from 'src/app/services/staticcontent.service';
import { PageComponent } from '../../base.component';

@Component({
    selector: 'app-static',
    templateUrl: './static.component.html',
    styleUrls: ['./static.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StaticComponent extends PageComponent {

    public static route = "static";
    // Set inside the nested async subscribes below (both HTTP fetches, kicked off from the
    // effect() on a route id change) - not template-bound handlers, so these need to be signals
    // for OnPush to see the updates.
    protected content = signal<StaticContent>(undefined);
    protected contentInnerHtml = signal<string>(undefined);

    id = input<string>();

    public constructor(private staticContentService: StaticContentService, private coreAppService: ApplicationService) {
        super(coreAppService.authService, coreAppService.uiStateService);
        effect((onCleanup) => {
            const routeId = this.id();
            if (!routeId) { return; }
            let contentSub: Subscription;
            const staticContentSub = this.staticContentService.getStaticContentById(Number(routeId)).subscribe(staticContent => {
                this.content.set(staticContent);
                let contentSubpath = staticContent.ContentType == ContentType.Absolute ? 'absolute/' :
                    (ContentType.Blog ? 'news/' : '');
                contentSub = this.staticContentService.getContent(`assets/static/${contentSubpath}${staticContent.ContentFilePath}`).subscribe(retrievedContent => this.contentInnerHtml.set(retrievedContent.toString()));
            });
            onCleanup(() => {
                staticContentSub.unsubscribe();
                contentSub?.unsubscribe();
            });
        });
    }

}
